import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Container, Loader } from "src/components";
import { api } from 'src/utils';
import HandbookHeader from './handbook-header';
import SubCategories from './sub-categories';
import { getCategoryBySlug } from "src/data";
import HandbookArticle from "./article/handbook-article";
import { useIsMobile } from 'src/hooks';

export default function HandbookCategory() {
  const { category } = useParams();
  const isMobile = useIsMobile();
  const [categoryOverview, setCategoryOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const categoryGroup = getCategoryBySlug(category);

  useEffect(() => {
    const fetchCategoryData = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const categoryData = await api.get(`/handbook/category/${category}`);
        setCategoryOverview(categoryData.data);
      } catch (err) {
        console.error("Error fetching category data", err);
        setError("Failed to load category content");
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryData();
  }, [category]);

  const categoryTitleCase = category.split('-')
      .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
      .join(' ');

  if (loading) {
    return (<Loader />);
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        minHeight: '100%',
        background: '#FAFAFA',
        overflowY: 'auto', 
        width: '100%',
        pb: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
      
      {error ? (
        <HandbookHeader 
          id={category}
          title={categoryTitleCase}
          description={"Failed to load category"}
          displayBackButton={true}
          displayErrorAlert={true} />
      ) : ( <>

      <HandbookHeader 
        id={categoryOverview?.id}
        title={categoryOverview?.shortTitle}
        description={categoryOverview?.description}
        showControlButtons={true}
        category={category}/>
      
      <Box sx={{ width: '100%', py: 2, px: isMobile ? 2 : '10vw' }}>
        <SubCategories 
              articles={categoryOverview?.subcategories} 
              category={categoryOverview?.slug}
              categoryColor={categoryGroup?.group.color}/>
      </Box>
      
      <HandbookArticle 
        id={categoryOverview?.id}
        title={categoryOverview?.title}
        markdown={categoryOverview?.markdown}
        relatedArticles={[]} />

      </>)}

    </Box>
  );
}